import React, { useEffect, useState } from "react";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import { PRESCRIPTIONMAIL } from "common/viewContent";
import * as Path from "routes/Path/index";
import { toast } from "react-toastify";
import Table from "components/Table";
import { Link, useNavigate } from "react-router-dom";
import { getPrescriptionMailList } from "store/actions";
import Columns from "./Columns";

const List = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { PRESCRIPTIONMAILLIST, loading, totalCount } = useSelector(
    (state) => state.MailPrescription
  );
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const [mail, setMail] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [search_text, setSearch_text] = useState();
  const [filter, setFilter] = useState({
    pageNo: currentPage,
    limit: pageSize,
    search_text: "",
  });

  const fetchData = async (filter) => {
    const payload = {
      ...filter,
      page: filter?.pageNo,
      record_count: filter?.limit,
    };
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          setMail(res);
        }
      };
      dispatch(getPrescriptionMailList({ data: payload, callback }));
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  useEffect(() => {
    fetchData(filter);
    setcolumns(
      Columns({
        handleViewMail,
        currentPage: filter?.pageNo,
        pageSize,
      })
    );
  }, [filter]);
  const onClickFilter = (e) => {
    e?.preventDefault();
    setFilter({
      ...filter,
      pageNo: 1,
      limit: pageSize,
      search_text: search_text,
    });
  };
  const clearFilter = () => {
    setFilter((pre) => ({
      ...pre,
      pageNo: 1,
      search_text: "",
    }));
    setSearch_text("");
  };
  const handleTableChange = (pageNumber, newPageSize) => {
    setCurrentPage(pageNumber);
  };
  const handleViewMail = (summary) => {
    navigate(`/admin/mail/prescription-mail/detail`, {
      state: { summary: summary },
    });
  };
  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <Helmet title={PRESCRIPTIONMAIL.CURRENT_MODULE} />
      <section className="section">
        <div className="section-header">
          <h1>{PRESCRIPTIONMAIL.CURRENT_MODULE}</h1>
          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.dashboard}>Dashboard</Link>
            </div>
            <div className="breadcrumb-item">
              {PRESCRIPTIONMAIL.CURRENT_MODULE}{" "}
            </div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">
                    {PRESCRIPTIONMAIL.TOP_CONTENT}
                  </h2>
                </div>
              </div>
              <div className="col-12">
                <form onSubmit={onClickFilter}>
                  <div className="card-header">
                    <div className="col-lg-4 col-sm-12 col-md-12 my-2 px-0">
                      <input
                        className="form-control"
                        name="search_text"
                        onChange={(e) => setSearch_text(e.target.value)}
                        value={search_text}
                        placeholder="Search using name, email..."
                      />
                    </div>
                  </div>
                  <div className="col-12 my-2 gap-4 ">
                    <div className="d-flex gap-4">
                      <button type="submit" className="btn btn-primary btn-lg">
                        Search
                      </button>
                      <button
                        onClick={() => clearFilter()}
                        type="button"
                        className="btn btn-primary btn-lg"
                      >
                        Clear Search
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {!loading && PRESCRIPTIONMAILLIST?.users?.length > 0 && (
            <Table
              data={PRESCRIPTIONMAILLIST?.users}
              columns={columns}
              setFilter={setFilter}
              handleTableChange={handleTableChange}
              totalCount={totalCount}
              filter={filter}
            />
          )}
          {!loading && PRESCRIPTIONMAILLIST?.length === 0 && (
            <p style={{ textAlign: "center" }}>No Prescription Found</p>
          )}
        </div>
      </section>
    </>
  );
};
export default List;
